import Field from "csi/def/Field";
import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import ProductSelectProductHierarchyForm from "src/SiteAdmin/ProductHierarchy/ProductSelectProductHierarchyForm";

export = declare(ProductSelectProductHierarchyForm, {
	productType: "RetailProduct",
	
	/**
	 * @override
	 * Add Subtype field
	 */
	_resolveView() {
		this.insertField(lang.mixin(new Field(), {
			m_id: "Subtype",
		}), 0);

		this.inherited(arguments);
	},
});